import { copyToClipboard } from '@/helpers/copyToClipboard';
import { useScreen } from '@/hooks/useScreen';
import useToast from '@/hooks/useToast';
import { convertQuantity } from 'common/quantityHelpers';
import { PostContext } from 'context/PostContext';
import Button from 'design-system/components/Button/Button';
import {
  ButtonEmphasis,
  ButtonSize,
} from 'design-system/components/Button/types';
import dynamic from 'next/dynamic';
import { useContext, useState } from 'react';
import FloatingPostMenuHelper from './FloatingPostMenuHelper';

const Tooltips = dynamic(
  () => import('design-system/components/Tooltips/Tooltips')
);

const PostShareButton = () => {
  const postInfo = useContext(PostContext);

  const [shareCount, setShareCount] = useState(postInfo.sharesCount);
  const toast = useToast();

  const { isDesktop } = useScreen();

  const handleShare = async () => {
    try {
      await (
        await import('../../../../../../apis/tms/post.api').then(
          (mod) => mod.postIncreaseShareCount
        )
      )(postInfo.postId);
      setShareCount((prev) => prev + 1);
    } catch (error) {
      console.log(error);
    }
  };

  const handleOnClickShare = () => {
    const shareUrl = `${window.location.origin}/home/${postInfo.postId}`;

    if (navigator.share) {
      navigator.share({
        url: shareUrl,
      });
      handleShare();
    } else {
      copyToClipboard(shareUrl, () =>
        toast('Đã sao chép liên kết thành công', 'success')
      );
    }
  };

  const buttonProps: {
    onClick: () => void;
    size: ButtonSize;
    emphasis: ButtonEmphasis;
  } = {
    onClick: handleOnClickShare,
    size: 'medium',
    emphasis: 'medium',
  };

  return (
    <div>
      {isDesktop ? (
        <>
          <Tooltips title={'Chia sẻ'}>
            <Button
              {...buttonProps}
              mode="icon-only"
              icon={{
                name: 'share',
              }}
            />
          </Tooltips>
          <FloatingPostMenuHelper>
            {convertQuantity(shareCount)}
          </FloatingPostMenuHelper>
        </>
      ) : (
        <Button
          {...buttonProps}
          mode="text-only"
          startIcon={{
            name: 'share',
          }}
        >
          {convertQuantity(shareCount)}
        </Button>
      )}
    </div>
  );
};

export default PostShareButton;
